var _g, _line, _rect, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShadeGuideOutsideCeilingHeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "422px",
    height: "510px",
    viewBox: "0 0 422 510",
    enableBackground: "new 0 0 422 510",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M388.2,5.7c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4s0.4-0.8,0.7-1.1s0.6-0.5,1-0.7s0.8-0.3,1.3-0.3 c1,0,1.8,0.4,2.4,1.3L393,2.6c-0.2-0.3-0.4-0.5-0.7-0.7c-0.3-0.2-0.6-0.3-1-0.3c-0.7,0-1.3,0.3-1.7,0.8c-0.5,0.5-0.7,1.2-0.7,2 c0,0.5,0.1,1,0.3,1.4c0.2,0.4,0.5,0.7,0.9,1s0.8,0.3,1.2,0.3c0.4,0,0.7-0.1,1-0.3s0.6-0.4,0.7-0.7l0.7,0.4 c-0.6,0.9-1.4,1.3-2.4,1.3c-0.5,0-0.9-0.1-1.3-0.3s-0.7-0.4-1-0.7S388.4,6.2,388.2,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M394.6,7.7V1h4.2v0.7h-3.4v2.1h3.3v0.7h-3.3v2.3h3.4v0.7H394.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M400,7.7V1h0.8v6.7H400z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M402.2,7.7V1h0.8v5.9h2.9v0.7H402.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M407,7.7V1h0.8v6.7H407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M409.2,7.7V1h0.8l3.6,5.2V1h0.8v6.7h-0.8L410,2.3v5.3H409.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M416,5.8c-0.2-0.4-0.3-0.9-0.3-1.4s0.1-1,0.3-1.4c0.2-0.4,0.4-0.8,0.7-1.1c0.3-0.3,0.6-0.5,1-0.7 c0.4-0.2,0.8-0.2,1.3-0.2c1,0,1.8,0.4,2.5,1.2l-0.6,0.4c-0.2-0.3-0.5-0.5-0.8-0.7s-0.7-0.2-1-0.2c-0.7,0-1.3,0.3-1.7,0.8 c-0.5,0.5-0.7,1.2-0.7,1.9c0,0.5,0.1,1,0.3,1.4s0.5,0.7,0.9,1c0.4,0.2,0.8,0.3,1.2,0.3c0.4,0,0.7-0.1,1-0.2 c0.3-0.1,0.5-0.3,0.7-0.5V5h-2.2V4.2h3v2.4c-0.3,0.4-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.4,0.3c-0.4,0-0.9-0.1-1.3-0.3 c-0.4-0.2-0.7-0.4-1-0.7C416.4,6.6,416.1,6.2,416,5.8z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#474646",
    strokeWidth: 1.9844,
    x1: 0,
    y1: 5.9,
    x2: 385.5,
    y2: 5.9
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 10.2,
    fill: "#DCDCDC",
    width: 349,
    height: 402
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 70.9,
    y: 104.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 280.1,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 127.6,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 2.9998,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.6349,
    x1: 211,
    y1: 487.6,
    x2: 211,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.9,486.2 211,494.7 206.1,486.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "215.9,18.6 211,10.2 206.1,18.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.638,
    x1: 304,
    y1: 487.6,
    x2: 304,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "308.9,486.2 304,494.7 299.1,486.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "308.9,18.7 304,10.2 299.1,18.7  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 1.638,
    x1: 118,
    y1: 487.6,
    x2: 118,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "122.9,486.2 118,494.7 113.1,486.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "122.9,18.7 118,10.2 113.1,18.7  "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadeGuideOutsideCeilingHeight);
export default __webpack_public_path__ + "static/media/ShadeGuide-Outside-Ceiling-Height-٠١.20d2161a3f1bbdb86dcc1620c48d24c6.svg";
export { ForwardRef as ReactComponent };